module.exports = __webpack_public_path__ + "static/one-pitch-at-a-time-25f29c19ba4a7c0d157ec17c9af1a247.jpg";